module.exports = __webpack_public_path__ + "static/media/centre_medial_bonnevoie_annexe_entree.2fba92ec.jpg";